module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/flashpoint-d4a5c22c70ac8bc2d7b9962dab6cd20b.svg";